const translations = {
    autoResolvedDescription:
        'This application is tagged for a John Deere field. Confirm to export.',
    cancelButton: 'Cancel',
    closeButton: 'Close',
    errorGeneric: 'Export failed. Please try again.',
    errorTitle: 'Export Failed',
    exportButton: 'Export',
    fieldsLabel: 'Field',
    noFields: 'No fields found for this organization.',
    noOrganizations: 'No connected John Deere organizations.',
    organizationsLabel: 'Organization',
    pickerDescription: 'Select a John Deere organization and field for this export.',
    resolving: 'Finding target field...',
    retryButton: 'Retry',
    selectOrganizationPrompt: 'Select an organization to load fields.',
    stepDone: 'Done',
    stepFileResource: 'Creating file resource',
    stepMapLayer: 'Creating map layer',
    stepSummary: 'Preparing export',
    stepUpload: 'Uploading to John Deere',
    successDescription: 'Map layer exported successfully.',
    successTitle: 'Export Complete',
    successViewLink: 'View in John Deere Operations Center',
    title: 'Export to John Deere'
};

export default translations;
